import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'properties-module';

export function handleNext() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.next.click', edapData);
}

export function handlePrev() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.previous.click', edapData);
}
